import React from 'react';
import dmImage from "../../../assets/images/approvals/dm.png";
import dmccImage from "../../../assets/images/approvals/approval1.jpg";
import difcImage from "../../../assets/images/approvals/rta.png";

import dcdImage from "../../../assets/images/approvals/dcd.png";
import traImage from "../../../assets/images/approvals/trakhees.png";

import { CiCircleChevRight } from "react-icons/ci"; 
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';
import { FaQuoteRight } from "react-icons/fa";
import Metatag from '../../Metatag/Metatag';

const Multicommodities = () => {
  return (
    <div className="container relative">
<Metatag title="Multi-Commodity Approval Services - Streamline Your Approvals | Megavolt Technical Services" description="Efficient multi-commodity approval solutions tailored to your business needs. Megavolt Technical Services ensures smooth regulatory compliance for diverse commodities. Contact us today!" link="approval/municipality-approval"/>
      <div className="grid grid-cols-1 md:grid-cols-12 gap-5 py-8 md:py-16">
        {/* Main Content */}
        <div className="col-span-12 md:col-span-8 p-3">
          <div className="w-[200px] border">
            <img src={dmccImage} alt="Our Story" className="w-full h-full" />
          </div>
          <div className="my-5">
            <h1 className="text-2xl font-bold capitalize dark:text-[#dddddd] md:text-3xl">
              Dubai Electricity and Water Authority (DEWA) Approved Contractor
            </h1>
            <p className="pl-3 pt-2">
              We are a trusted DEWA Approved Contractor in Dubai, providing complete support for DEWA approvals, electrical works, power connections, load approvals, and water services. Our expert team ensures full compliance with Dubai Electricity and Water Authority (DEWA) regulations, safety standards, and technical requirements, delivering approvals and execution efficiently and on schedule.
            </p>
             <p className="pl-3 pt-2">
              Looking for fast and reliable DEWA approval in Dubai? Contact Megavolt today for professional and hassle-free DEWA approval services.
            </p>
          </div>
                                <div className="my-5">
            <h1 className="text-2xl font-bold capitalize dark:text-[#dddddd] md:text-3xl">
              About Our DEWA Approval Services
            </h1>
            <p className="pl-3 pt-2">
              DEWA approval is mandatory for any project involving electrical installations, power supply connections, load extensions, water connections, LV/HV works, substations, and electrical fit-out works in Dubai. As a DEWA-certified contractor, we manage the complete DEWA approval process—from documentation and drawings to inspections and final energization—ensuring your project proceeds without delays or compliance issues.
            </p>
             <p className="pl-3 pt-2">
              Our DEWA approval services are tailored for residential, commercial, industrial, and fit-out projects across Dubai.
            </p>
          </div>

          {/* Requirements List */}
          <div className="my-10">
            <h2 className="text-2xl font-bold capitalize dark:text-[#dddddd] md:text-3xl">
              Why Choose a DEWA Approved Contractor?
            </h2>
            <ul className="list-disc ml-10 space-y-2 pt-2">
              <li>Fully compliant with DEWA rules and Dubai regulations.</li>
              <li>Faster and smoother DEWA approval process.</li>
              <li>Certified electrical engineers and DEWA-approved supervisors.</li>
              <li>Approved materials, equipment, and safety systems.</li>
              <li>Reduced risk of rejection, penalties, or project delays.</li>
              <li>End-to-end approval and execution support.</li>
              <li>Reliable project delivery with on-time energization.</li>
            </ul>
          </div>

          {/* Approval Process */}
          <div className="my-5">
            <h2 className="text-2xl font-bold capitalize dark:text-[#dddddd] md:text-3xl">
              DEWA Approval Process in Dubai – Step by Step
            </h2>
            {[
              "Initial Consultation: We review your project scope, electrical load requirements, and DEWA standards.",
              "Contractor & Project Registration: Registration of the company, engineers, and project details with DEWA systems.",
              "Document & Drawing Submission: Submission of electrical drawings, load schedules, schematics, and technical documents.",
              "Technical Review by DEWA: Evaluation of electrical design, safety compliance, and system requirements.",
              "Site Inspection & Testing: DEWA inspection of installations, testing of systems, and verification of safety measures.",
              "Final DEWA Approval & Power Connection: Issuance of DEWA approval and authorization for power and water connection.",
            ].map((step, index) => (
              <div className="flex" key={index}>
                <div className="mr-5 relative pt-2">
                  <span className="bg-orange text-white flex items-center justify-center w-12 h-12 rounded-full shadow-md">
                    {index + 1}
                  </span>
                </div>
                <p className="flex-1 mb-10 pt-3 ">{step}</p>
              </div>
            ))}
          </div>

          {/* Essential Documents 
          <div className='md:my-10 my-6'>
                        <h2 className="text-2xl font-bold capitalize dark:text-[#dddddd] md:text-3xl">
              Essential Documents for DMCC Approved Contractors
            </h2>
            <ul className="ml-4 md:ml-10 space-y-2">
              {[
                "Engineering Degree: Proof of formal education in Civil or Structural Engineering.",
                "Experience Certificate: Documented industry experience, verified for credibility.",
                "UAE Society of Engineers Membership: Ensures compliance with all legal standards.",
                "Trade License: Legal documentation for operating within the DMCC jurisdiction.",
                "Project Plans & Blueprints: Detailed drawings for approval and implementation."
              ].map((doc, index) => (
                <li className="flex" key={index}>
                  <CiCircleChevRight className="text-2xl mt-2 text-orange w-6" />
                  <span className="ml-2 mt-2">{doc}</span>
                </li>
              ))}
            </ul>
                        </div>*/}
                            <div className="my-5">
            <h1 className="text-2xl font-bold capitalize dark:text-[#dddddd] md:text-3xl">
              Trusted DEWA Approval Experts in Dubai
            </h1>
            <p className="pl-3 pt-2">
              With strong expertise in DEWA regulations, electrical standards, and approval workflows, Megavolt ensures your DEWA approvals are handled professionally and efficiently. Whether it’s a fit-out project, commercial building, villa, or industrial facility, we deliver reliable DEWA approval solutions in Dubai.

            </p>
                      <p className="pl-3 pt-2">
              Call our DEWA experts at +971 55 481 2897 for fast, compliant, and hassle-free DEWA approvals.
            </p>
          </div>
        </div>

        {/* Sidebar */}
        <div className="col-span-12 md:col-span-4 p-3">
          <div className="sticky top-16 border border-[#bcbcbc] p-3 rounded-lg bg-[#e8eaed]">
            <p className="uppercase text-center mb-5 text-xl font-bold">Other Authority Approval</p>
            {[dmImage, dmccImage, difcImage].map((img, idx) => (
              <div key={idx} className="border border-orange w-3/5 mx-auto mb-5">
                <img src={img} alt="Approval logo" className="w-full h-full" />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Testimonials Section */}
      <div className='p-3 md:py-12'>
        <div className="text-center my-2">
          <h1 className=" font-bold text-2xl md:text-3xl text-center uppercase">What Clients Say</h1> 
        </div>
        <p className="text-center text-orange lg:text-2xl text-xl">
          We care about our clients, so we are popular
        </p>
        <div className="md:my-10 my-8">
          <Swiper
            pagination={{ clickable: true }}
            modules={[Pagination]}
            className="mySwiper"
            slidesPerView={1}
            spaceBetween={30}
            breakpoints={{
              640: { slidesPerView: 1, spaceBetween: 20 },
              768: { slidesPerView: 1, spaceBetween: 40 },
              1024: { slidesPerView: 1, spaceBetween: 50 }
            }}
          >
            {[...Array(3)].map((_, index) => (
              <SwiperSlide className='md:p-12 p-4' key={index}>
                <div className='mb-[40px] shadow-[0_5px_20px_#01010145] p-5 rounded-xl'>
                  <div className='text-center shadow-[0_1rem_3rem_rgba(0, 0, 0, .18)]'>
                    <div className='flex items-center justify-center'>
                      <FaQuoteRight className='text-orange text-[40px] mb-5' />
                    </div>
                    <p className='text-center md:text-lg text-base'>
                      Team did an amazing job for us. On a very short time plan they developed a great presentation out of a word report. Communication was fast, uncomplicated and wished changes were done within hours. I can highly recommend them.
                    </p>
                    <h1 className='text-center font-bold mt-3'>John Hanks, Entrepreneur</h1>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default Multicommodities;
